var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home_doctor",
    attrs: {
      "data-testid": "doctor-dashboard"
    }
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('visits')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('tasks')], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-231d91c2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/HomeDoctor/HomeDoctor.vue
// module id = 398
// module chunks = 0